import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import ChallengeRow from './ChallengeRow';

export default function ChallengeDataGrid(props) {
  const { playful = false, challenges, setChallenges, setParam, orderByPeriod, orderByParticipants, setOrderByPeriod, setOrderByParticipants, orderByAccuracy, setOrderByAccuracy } = props;
  const orderButtonClass = playful ? 'card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer rounded-lg bg-[var(--color-bg-mission-soft)] text-neutral-900' : 'card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer';

  return (
    <div className="round-dg-wrapper">
      <table
        className="round-dg round-dg--light"
        style={{ minWidth: 1000, fontSize: 14 }}
      >
        <thead className="round-dg__header">
          <tr className="round-dg__row">
            <th className="round-dg__cell-header round-dg__cell-header--sm">Desafio</th>
            <th
              className="round-dg__cell-header round-dg__cell-header--sm"
              style={{ width: 140 }}
            >
              Tema
            </th>
            <th
              className="round-dg__cell-header round-dg__cell-header--sm"
              style={{ width: 120 }}
            >
              Período{' '}
              <span className={orderButtonClass}>
                {orderByPeriod === 'descendent' ? (
                  <FiChevronDown
                    onClick={() => {
                      setOrderByPeriod('ascendent');
                      setParam('period');
                    }}
                    className="card__icon"
                  />
                ) : (
                  <FiChevronUp
                    onClick={() => {
                      setOrderByPeriod('descendent');
                      setParam('period');
                    }}
                    className="card__icon"
                  />
                )}
              </span>
            </th>
            <th
              className="round-dg__cell-header round-dg__cell-header--sm"
              style={{ width: 160 }}
            >
              Disponibilidade
            </th>
            <th
              className="round-dg__cell-header round-dg__cell-header--sm"
              style={{ width: 160 }}
            >
              Participantes{' '}
              <span className={orderButtonClass}>
                {orderByParticipants === 'descendent' ? (
                  <FiChevronDown
                    onClick={() => {
                      setOrderByParticipants('ascendent');
                      setParam('participants');
                    }}
                    className="card__icon"
                  />
                ) : (
                  <FiChevronUp
                    onClick={() => {
                      setOrderByParticipants('descendent');
                      setParam('participants');
                    }}
                    className="card__icon"
                  />
                )}
              </span>
            </th>
            <th
              className="round-dg__cell-header round-dg__cell-header--sm"
              style={{ width: 132 }}
            >
              Índice de acerto{' '}
              <span className={orderButtonClass}>
                {orderByAccuracy === 'descendent' ? (
                  <FiChevronDown
                    onClick={() => {
                      setOrderByAccuracy('ascendent');
                      setParam('accuracy');
                    }}
                    className="card__icon"
                  />
                ) : (
                  <FiChevronUp
                    onClick={() => {
                      setOrderByAccuracy('descendent');
                      setParam('accuracy');
                    }}
                    className="card__icon"
                  />
                )}
              </span>
            </th>
            <th
              className={playful ? 'round-dg__cell-header' : 'round-dg__cell-header round-dg__cell-header--sm'}
              style={{ width: 152 }}
            ></th>
          </tr>
        </thead>

        <tbody className="round-dg__body">
          {challenges.map((item, key) => (
            <ChallengeRow
              playful={playful}
              challenge={item}
              total={challenges.length}
              index={key}
              key={key}
              setChallenges={setChallenges}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
